import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

const TipOptional = styled.div`
  text-align: center;
`;

const TipLabelStyled = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
`;

export const TipLabel = () => {
  const { formatMessage } = useIntl();
  return (
    <TipOptional>
      <TipLabelStyled>
        {formatMessage({
          id: 'tip',
        })}
      </TipLabelStyled>{' '}
      (
      {formatMessage({
        id: 'optional100PercentGoesToDriver',
      })}
      )
    </TipOptional>
  );
};
